"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomToolbarItem = void 0;
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../../../helpers");
const CustomToolbarItem_styles_1 = require("./CustomToolbarItem.styles");
exports.CustomToolbarItem = (0, helpers_1.createUIElement)('CustomToolbarItem', ({ itemProps }, ref) => {
    if (itemProps.render && !itemProps.hidden) {
        return (react_1.default.createElement(CustomToolbarItem_styles_1.StyledCustomToolbarItem, { ref: ref, "data-has-offset": itemProps.hasOffset, hasOffset: itemProps.hasOffset, isStretch: itemProps.hasStretch }, itemProps.render({ disabled: Boolean(itemProps.disabled) })));
    }
    return null;
});
//# sourceMappingURL=CustomToolbarItem.js.map